import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { GameContextProvider } from 'contexts/GameContext';
import Navigation from 'components/Navigation';
import Game from 'components/Game';
import Copyright from 'components/Copyright';
import Page, { Content, Footer } from 'containers/Page';

const GamePage = () => {
  const location = useLocation();
  const path = location.pathname.split('/');
  const id = path[path.length - 1];
  const source = useMemo(
    () => location.hash
      ? new URLSearchParams(location.hash.substring(1))
        .get('source')
      : null,
    [location.hash]
  );

  return (
    <Page>
      <GameContextProvider id={id} source={source}>
        <Content>
          <Navigation />
          <Game />
        </Content>
        <Footer>
          <Copyright />
        </Footer>
      </GameContextProvider>
    </Page>
  );
}

export default GamePage;
